import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const YourCases = ({
  cases,
  onCreateNew,
  onCaseClick,
  onDeleteCase,
  isViewer = false,
}) => {
  return (
    <div className="mb-8">
      <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-4 gap-4 sm:gap-0">
        <div>
          <h2 className="text-lg font-bold text-primary">Your Cases</h2>
          <p className="text-sm text-muted">
            Track and manage your support requests
          </p>
        </div>
        {!isViewer && (
          <button
            onClick={onCreateNew}
            className="w-60 sm:w-auto bg-primary text-white sm:px-4 p-2 rounded-md text-xs sm:text-sm font-semibold hover:bg-primary/90 transition-colors flex items-center gap-1 justify-center"
          >
            + CREATE NEW SUPPORT REQUEST
          </button>
        )}
      </div>

      <div className="space-y-3">
        {cases.map((caseItem) => (
          <div
            key={caseItem.id}
            className={`bg-white border border-line rounded-2xl px-4 sm:px-5 py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 transition-shadow ${!isViewer ? "hover:shadow-md cursor-pointer" : "cursor-default"}`}
            onClick={() => !isViewer && onCaseClick(caseItem)}
          >
            <div>
              <h3 className="text-sm font-semibold text-primary">
                {caseItem.title}
              </h3>
              <p className="text-xs text-muted mt-1">{caseItem.subtitle}</p>
              <p className="text-xs text-muted mt-1">
                Created {caseItem.createdAgo || caseItem.date}, last modified{" "}
                {caseItem.updatedAgo || caseItem.date}
              </p>
            </div>
            {!isViewer && (
              <div className="flex items-center sm:gap-3 max-sm:w-full max-sm:justify-end">
                {caseItem.status === "open" ? (
                  <span className="bg-success text-white px-3 sm:px-4 py-2 rounded-md text-[10px] sm:text-xs font-semibold tracking-wide">
                    OPEN CASE
                  </span>
                ) : (
                  <span className="bg-primary/80 text-white px-3 sm:px-4 py-2 rounded-md text-[10px] sm:text-xs font-semibold tracking-wide">
                    CLOSED CASE
                  </span>
                )}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteCase(caseItem.id);
                  }}
                  className="px-2 pb-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                  title="Delete case"
                >
                  <DeleteOutlineIcon style={{ fontSize: "1.25rem" }} />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default YourCases;
